/* istanbul ignore file */
import { Link } from 'react-router-dom';
import { NEW_TAB_LINK_PROPS } from 'framework/utils';
import { useServiceUrl } from '../route/route';

const ServiceLink = ({
  id,
  name,
  isClickable = true,
  isOpenInNewTab,
}: {
  id: StringOrNumber;
  name?: string;
  isClickable?: boolean;
  isOpenInNewTab?: boolean;
}) => {
  const { getSingleEntityUrl } = useServiceUrl();

  return (
    <>
      {isClickable ? (
        <Link to={getSingleEntityUrl(id)} {...(isOpenInNewTab && NEW_TAB_LINK_PROPS)}>
          {name || id}
        </Link>
      ) : (
        <span>{name || id}</span>
      )}
    </>
  );
};

export default ServiceLink;
